/**
 * Rybbit — self-hosted product analytics at analytics.carofi.app, replacing
 * Amplitude.
 *
 * THIS APP HAS ITS OWN SITE ID (2, "client.web.admin").
 *
 * Each of the six Carofi apps is a separate Rybbit site, so each gets its own
 * dashboard, segments and clients. Know the trade-off that comes with it:
 * Rybbit scopes every query to one site — the ClickHouse events table is sorted
 * by (site_id, timestamp) and this build has no cross-site rollup — so a funnel
 * CANNOT span two apps. The customer web -> customer app finance journey, and
 * the partner web <-> partner app auto-merchant funnels (whose event names are
 * kept byte-identical across the two platforms for exactly that reason), can
 * only be analysed per-app while the sites are split.
 *
 * The `app` global property is still attached to every event. It is redundant
 * with the site split today, and deliberately kept: it costs nothing, and if
 * these sites are ever consolidated into one it is what makes the per-app view
 * survive the merge.
 *
 * NO DEFAULT SITE ID. An unset id means the tracker is never loaded and
 * tracking is a no-op — loud in dev, harmless in prod — rather than silently
 * writing into the wrong project.
 */
export const TRACKING_RYBBIT_HOST =
  import.meta.env.VITE_RYBBIT_HOST || 'https://analytics.carofi.app';

export const TRACKING_RYBBIT_SITE_ID = import.meta.env.VITE_RYBBIT_SITE_ID || '';

export const SURVEY_MODULE_TRACKING = {
  SUB_VIEWS: {},
  EVENTS: {}
};
